import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { A6IssuersEdit } from "./edit";
import { A6IssuersNew } from "./new";
import { A6IssuersTable } from "./table";

export default function A6Issuers() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Émetteurs");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<A6IssuersEdit />} />
      <Route index element={<A6IssuersTable />} />
      <Route path="/new" element={<A6IssuersNew />} />
    </Routes>
  );
}
